import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicLayout = () => {
  return (
    <>
      {/* Pas de Header ici */}
      <Outlet />
    </>
  );
};

export default PublicLayout;
